import React from 'react';
import { FaGithub, FaLinkedin, FaEnvelope, FaArrowRight } from 'react-icons/fa';

const EASE = 'cubic-bezier(0.4, 0, 0.2, 1)';
const T = `transform 0.4s ${EASE}, box-shadow 0.4s ${EASE}`;

const socialBtn = {
  width: '44px', height: '44px',
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
  borderRadius: '10px', border: '1px solid var(--border-subtle)',
  color: 'var(--text-muted)', textDecoration: 'none', cursor: 'pointer',
  transform: 'translateY(0)',
  transition: `${T}, color 0.3s ease, background 0.3s ease, border-color 0.3s ease`,
};

const emailBtn = {
  display: 'inline-flex', alignItems: 'center', gap: '10px',
  padding: '16px 36px', background: 'var(--accent)', color: '#FFFFFF',
  fontWeight: 600, fontSize: '1rem', border: 'none',
  borderRadius: '100px', cursor: 'pointer', textDecoration: 'none',
  transform: 'translateY(0)',
  transition: `${T}, background 0.3s ease`,
};

const onSocialIn = (e) => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 6px 20px rgba(var(--accent-rgb),0.15)'; e.currentTarget.style.color = 'var(--accent)'; e.currentTarget.style.background = 'var(--accent-soft)'; e.currentTarget.style.borderColor = 'var(--border-hover)'; };
const onSocialOut = (e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.color = 'var(--text-muted)'; e.currentTarget.style.background = 'transparent'; e.currentTarget.style.borderColor = 'var(--border-subtle)'; };
const onEmailIn = (e) => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 8px 28px rgba(var(--accent-rgb),0.35)'; e.currentTarget.style.background = 'var(--accent-hover)'; };
const onEmailOut = (e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.background = 'var(--accent)'; };

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="contact" className="footer-section">
      <div style={{ maxWidth: '1500px', margin: '0 auto', padding: '0 24px' }}>
        <div className="footer-cta-area reveal">
          <div className="section-label" style={{ justifyContent: 'center', marginBottom: '1.5rem' }}>Contacto</div>
          <h2>¿Listo para crear <span className="text-gradient">algo increíble?</span></h2>
          <p>Estoy disponible para nuevos proyectos y colaboraciones.</p>
          <a href="mailto:andresscoronel77@gmail.com" style={emailBtn} onMouseEnter={onEmailIn} onMouseLeave={onEmailOut}>
            <FaEnvelope size={15} /> Envíame un email <FaArrowRight size={12} />
          </a>
        </div>

        <div className="footer-socials reveal">
          <a href="https://github.com/AndressCoronel" target="_blank" rel="noopener noreferrer" style={socialBtn} aria-label="GitHub" onMouseEnter={onSocialIn} onMouseLeave={onSocialOut}>
            <FaGithub size={18} />
          </a>
          <a href="https://www.linkedin.com/in/andres-coronel-164767263/" target="_blank" rel="noopener noreferrer" style={socialBtn} aria-label="LinkedIn" onMouseEnter={onSocialIn} onMouseLeave={onSocialOut}>
            <FaLinkedin size={18} />
          </a>
          <a href="mailto:andresscoronel77@gmail.com" style={socialBtn} aria-label="Email" onMouseEnter={onSocialIn} onMouseLeave={onSocialOut}>
            <FaEnvelope size={18} />
          </a>
        </div>

        <div className="footer-bottom">
          <p>
            © {currentYear} Andres Coronel · Hecho con <span style={{ color: 'var(--accent)', fontWeight: 600 }}>React</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;